<template>
<div class="add-new-account">
  <row>
    <div class="sl-col-4">
      <div class="sl-form">
        <el-form ref="form" :model="form" label-width="120px" v-loading="loading">
          <el-form-item :label="label.username">
            <el-input v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item :label="label.name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item :label="label.password">
            <el-input v-model="form.password" type="password"></el-input>
          </el-form-item>
          <el-form-item :label="label.phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item :label="label.email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item :label="label.admin">
            <el-radio class="radio" v-model="form.admin" label="1">{{$tc('Functional.yes',2)}}</el-radio>
            <el-radio class="radio" v-model="form.admin" label="0">{{$tc('Functional.no',2)}}</el-radio>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onSubmit" :disabled="form.username === '' || form.password === ''">{{$t('Button.save')}}</el-button>
            <router-link tag="el-button" :to="{ name: 'Accounts' }" @click.native="$ga.event('Link', 'Cancel', 'Add new account')">{{$t('Button.cancel')}}</router-link>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </row>
</div>
</template>
<style>
@media only screen and (max-width: 768px) {
  .add-new-account .el-form-item__content {
    margin-left: 0 !important;
  }
  .add-new-account .el-form-item__label {
    text-align: left;
    width: 100% !important;
  }
}
</style>
<script>
import api from '../../../api'
export default {
  name: 'add-new-account',
  created() {
    this.label = {
      name: this.$t('Views.AddNewAccount.form.name'),
      username: this.$t('Views.AddNewAccount.form.username'),
      phone: this.$t('Views.AddNewAccount.form.phone'),
      email: this.$t('Views.AddNewAccount.form.email'),
      admin: this.$t('Views.AddNewAccount.form.admin'),
      password: this.$t('Views.AddNewAccount.form.password')
    }
  },
  data() {
    return {
      loading: false,
      label: {},
      form: {
        name: '',
        username: '',
        password: '',
        phone: '',
        email: '',
        admin: '1'
      }
    }
  },
  methods: {
    errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      })
    },
    onSubmit() {
      this.$ga.event('Button', 'Save', 'Add new account')
      const vm = this
      vm.loading = true
      api.SaveNewAccount(this.form).then(res => {
        if (res.data.code === 200) {
          vm.successMsg(res)
          vm.$router.push({
            name: 'Accounts'
          })
        } else {
          vm.errorMsg(res)
        }
        vm.loading = false
      }).catch(error => {
        alert(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// add-new-account.vue?01fe0690